import styles from './mobileShot.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
const MobileShot = () => {
  useEffect(() => {
      ScrollTrigger.create({
        trigger: `.${styles.svg}`,
        start: 'top 75%',
        onEnter: () => {
            document.querySelector(`.${styles.svg}`).classList.add("active")
        }
      })

      window.addEventListener("load", () => {
        ScrollTrigger.refresh()
    } );
  });
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svg}
    >
      <path
        className={styles.body}
        d="M28.5 10.5L83.5 10.5V101.5H28.5V10.5Z"
        stroke="#F8F6EC"
      />
      <path
        className={styles.plus}
        d="M50 44.5H56.5M56.5 44.5H63M56.5 44.5V38M56.5 44.5V51"
        stroke="#F8F6EC"
      />
      <g className={styles.viewfinder}>
        <path
          className={styles.shotPath1}
          d="M44.5 34V26.5H52"
          stroke="#F8F6EC"
        />
        <path
          className={styles.shotPath2}
          d="M60 26.5L67.5 26.5L67.5 34"
          stroke="#F8F6EC"
        />
        <path
          className={styles.shotPath3}
          d="M52 61.5L44.5 61.5L44.5 54"
          stroke="#F8F6EC"
        />
        <path
          className={styles.shotPath4}
          d="M67.5 54L67.5 61.5L60 61.5"
          stroke="#F8F6EC"
        />
      </g>

      <g className={styles.shotButton}>
        <circle cx="56" cy="86" r="8" stroke="#F8F6EC" />
        <rect x="51" y="81" width="10" height="10" rx="5" fill="#F8F6EC" />
      </g>
    </svg>
  );
};

export default MobileShot;
